// CustomSegmentMarker.ts

import { Label, Tag } from 'konva/lib/shapes/Label';
import { Line } from 'konva/lib/shapes/Line';
import { emitEvent } from '@/services/event-emitter';
import { EventTypes } from '@/types/types';
import { hexToRGBA } from '@/utils/color-utils';
import Konva from 'konva';
import { arrowDownTag, segmentTag } from './MarkerFunctions';
import { CreateSegmentMarkerOptions, SegmentMarker } from "peaks.js"; // Zorg ervoor dat deze functies correct geïmporteerd zijn

class CustomSegmentMarker implements SegmentMarker {
  private _options: CreateSegmentMarkerOptions;
  private _group!: Konva.Group;
  private _labelTop!: Label;
  private _labelBottom!: Label;
  private _tagTop!: Tag;
  private _tagBottom!: Tag;
  private _line!: Line;

  constructor(options: CreateSegmentMarkerOptions) {
    this._options = options;
  }

  // Implementeer init met parameter type 'object'
  init(group: object): void {
    // Typecast het object naar Konva.Group binnen de methode
    this._group = group as Konva.Group;

    const color = this._options.segment.color as string;

    // Create top label
    this._labelTop = new Label({
      x: 0.5,
      y: 0.5, // top position
    });

    // Create top tag
    this._tagTop = segmentTag('segment-tag-top', this._options, 'top');
    this._labelTop.add(this._tagTop);

    // Optioneel: Voeg tekst toe aan de top label
    let labelText = this._options.segment.labelText;
    if (labelText) {
      labelText += ' ';
      /*
      this._textTop = new Text({
        text: labelText,
        fontFamily: 'Calibri',
        fontSize: 14,
        padding: 5,
        fill: 'white',
      });
      this._labelTop.add(this._textTop);
      */
    }

    // Create bottom label
    this._labelBottom = new Label({
      x: 0.5,
      y: (this._options.layer.getHeight() || 0) - 0.5, // bottom position
    });

    // Create bottom tag
    this._tagBottom = arrowDownTag('segment-tag-bottom', color);
    this._labelBottom.add(this._tagBottom);

    // Optioneel: Voeg tekst toe aan de bottom label
    if (labelText) {
      labelText += ' ';
      /*
      this._textBottom = new Text({
        text: labelText,
        fontFamily: 'Calibri',
        fontSize: 14,
        padding: 5,
        fill: 'white',
      });
      this._labelBottom.add(this._textBottom);
      */
    }

    // Add both labels to the group
    this._group.add(this._labelTop);
    this._group.add(this._labelBottom);

    // Vertical Line (optioneel)
    this._line = new Line({
      x: 0,
      y: 0,
      stroke: hexToRGBA(color, 0.7),
      strokeWidth: 1,
    });
    // this._group.add(this._line); // Optioneel, afhankelijk van je ontwerp

    this.fitToView();
    this.bindEventHandlers();
  }

  fitToView(): void {
    const height = this._options.layer.getHeight();

    const offsetTop = 0;
    const offsetBottom = 0;

    // Position top label
    this._labelTop.y(offsetTop);

    // Position bottom label
    this._labelBottom.y((height || 0) - offsetBottom);

    // Pas de lijn aan op basis van positie (optioneel)
    this._line.points([
      0.5,
      0,
      0.5,
      (height || 0) - offsetTop - offsetBottom
    ]);
  }

  private bindEventHandlers(): void {
    this._group.on('mouseenter', () => {
      emitEvent(EventTypes.SET_DOCUMENT_CURSOR, 'ew-resize');
    });
    this._group.on('dragmove', () => {
      emitEvent(EventTypes.SET_DOCUMENT_CURSOR, 'ew-resize');
    });
    this._group.on('dragstart', () => {
      emitEvent(EventTypes.SET_DOCUMENT_CURSOR, 'ew-resize');
    });
    this._group.on('mouseleave', () => {
      emitEvent(EventTypes.UNSET_DOCUMENT_CURSOR);
    });
  }
}

export { segmentTag, arrowDownTag };
export default CustomSegmentMarker;
